import { createIconComponent } from './helpers';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'

export const LeftArrowIcon = createIconComponent(faAngleLeft);
